import axios from "axios";
import React, { useRef, useState } from "react";
import {
    GoogleMap,
    LoadScript,
    Marker,
    StandaloneSearchBox,
} from "@react-google-maps/api";
import Swal from "sweetalert2";
import Spinner from "../../Spinner";

const ProductUbication = ({
    onboarding,
    setOnboarding,
    setPage,
    actualPage,
    setProductsAll,
}) => {
    const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const mapRef = useRef(null);
    const [searchBox, setSearchBox] = useState(null);
    const [siguiente, setSiguiente] = useState("Siguiente");
    const [coordinates, setCoordinates] = useState({
        lat: onboarding.latitud || -12.04318,
        lng: onboarding.longitud || -77.02824,
        zoom: onboarding.mapZoom || 11,
    });
    const [ubication, setUbication] = useState({
        property_address: onboarding.direccion_calle,
        property_number: onboarding.direccion_numero,
        property_city: onboarding.ciudad,
        property_region: onboarding.departamento,
        property_postalCode: onboarding.codigo_postal,
        property_country: onboarding.pais,
    });
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };

    const handleInputChange = (e) => {
        setUbication({
            ...ubication,
            [e.target.name]: e.target.value,
        });
    };

    const updateProduct = async (payload) => {
        setSiguiente(null);
        if (onboarding.tipo_producto === "casa") {
            const { data } = await axios.put(
                `${process.env.REACT_APP_PROXY}/casa/actualizarMapa/${onboarding.id}`,
                payload,
                { headers }
            );
            if (data.message === "actuaizacion exitoso") {
                setOnboarding({
                    ...onboarding,
                    ...payload,
                });
                await axios.put(
                    `${process.env.REACT_APP_PROXY}/casa/actualizarPagina/${onboarding.id}`,
                    {
                        numero_pagina: actualPage + 1,
                    },
                    { headers }
                );
                setPage(actualPage + 1);
            }
        } else if (onboarding.tipo_producto === "embarcacion") {
            const { data } = await axios.put(
                `${process.env.REACT_APP_PROXY}/embarcacion/actualizarMapa/${onboarding.id}`,
                payload,
                { headers }
            );
            if (data.message === "actuaizacion exitoso") {
                setOnboarding({
                    ...onboarding,
                    ...payload,
                });
                await axios.put(
                    `${process.env.REACT_APP_PROXY}/embarcacion/actualizarPagina/${onboarding.id}`,
                    {
                        numero_pagina: actualPage + 1,
                    },
                    { headers }
                );
                setPage(actualPage + 1);
            }
        }
    };

    const nextPage = () => {
        const payload = {
            longitud: coordinates.lng,
            latitud: coordinates.lat,
            direccion_numero: ubication.property_number,
            direccion_calle: ubication.property_address,
            ciudad: ubication.property_city,
            departamento: ubication.property_region,
            codigo_postal: ubication.property_postalCode,
            pais: ubication.property_country,
            mapZoom: 14,
            id: onboarding.id,
        };

        if (
            payload.direccion_calle === "" ||
            payload.direccion_calle === null ||
            payload.direccion_calle === undefined
        )
            alert("Calle");
        else if (
            payload.direccion_numero === "" ||
            payload.direccion_numero === null ||
            payload.direccion_numero === undefined
        )
            alert("Numero");
        else if (
            payload.ciudad === "" ||
            payload.ciudad === null ||
            payload.ciudad === undefined
        )
            alert("Ciudad");
        else if (
            payload.departamento === "" ||
            payload.departamento === null ||
            payload.departamento === undefined
        )
            alert("Departamento/Estado/Provincia/Región");
        else if (
            payload.codigo_postal === "" ||
            payload.codigo_postal === null ||
            payload.codigo_postal === undefined
        )
            alert("Codigo postal");
        else if (
            payload.pais === "" ||
            payload.pais === null ||
            payload.pais === undefined
        )
            alert("Pais o región");
        else updateProduct(payload);
    };

    const alert = (alert) => {
        Swal.fire({
            title: `Debes completar el campo de dirección: ${alert}`,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Completar!",
        });
    };

    const handlePlacesChanged = () => {
        if (searchBox) {
            const places = searchBox.getPlaces();
            if (places.length === 0) return;

            const place = places[0];
            const location = place.geometry?.location;
            if (location) {
                setCoordinates({
                    lat: location.lat(),
                    lng: location.lng(),
                    zoom: 15,
                });
            }
        }
    };

    const onSearchBoxMounted = (ref) => {
        setSearchBox(ref);
    };

    return (
        <div className="">
            <div className="w-full h-screen md723:grid md723:grid-cols-2">
                <div className="bg-[#053465] h-1/3 md723:h-screen relative">
                    <div className="flex items-center justify-center h-full ">
                        <div className="absolute top-0 left-0 hidden ml-8 mt-7 md723:block">
                            <svg
                                width="56"
                                height="56"
                                viewBox="0 0 56 56"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.7726 30.3128C14.7726 30.0029 14.6998 29.736 14.5542 29.512C14.4086 29.288 14.2032 29.1125 13.9382 28.9893C13.6712 28.8661 13.3539 28.8045 12.9806 28.8045H11.1307V31.668H12.9283C13.5592 31.668 14.024 31.5485 14.3246 31.3096C14.6214 31.0707 14.7726 30.7384 14.7726 30.3128ZM47.8798 31.3749C47.624 31.892 47.2712 32.3624 46.8251 32.7861C46.379 33.2099 45.8358 33.5477 45.1955 33.7979C44.5552 34.048 43.8216 34.1731 42.9947 34.1731C41.9064 34.1731 40.932 33.9323 40.0734 33.4544C39.2128 32.9747 38.5352 32.2765 38.0387 31.3563C37.5422 30.4379 37.292 29.3179 37.292 28C37.292 26.6784 37.544 25.5565 38.0499 24.6381C38.5558 23.7197 39.239 23.0197 40.0995 22.5437C40.9619 22.0659 41.927 21.8288 42.9947 21.8288C43.7227 21.8288 44.3966 21.9296 45.0163 22.1312C45.6342 22.3328 46.1792 22.6259 46.6496 23.0104C47.12 23.3968 47.5008 23.8691 47.7958 24.4291C48.0888 24.9891 48.2718 25.6275 48.3427 26.348H45.4064C45.3672 26.0475 45.287 25.7749 45.1656 25.5323C45.0443 25.2896 44.8838 25.0824 44.684 24.9107C44.4843 24.7389 44.2491 24.6064 43.9766 24.5149C43.704 24.4235 43.4035 24.3768 43.075 24.3768C42.4907 24.3768 41.9886 24.5187 41.5686 24.8061C41.1486 25.0917 40.8256 25.5043 40.5998 26.0437C40.3758 26.5832 40.2619 27.2365 40.2619 28.0037C40.2619 28.8008 40.3758 29.4691 40.6054 30.0067C40.835 30.5443 41.1579 30.9493 41.5742 31.2219C41.9923 31.4944 42.4851 31.6288 43.0582 31.6288C43.3792 31.6288 43.6723 31.5877 43.9355 31.5056C44.2006 31.4235 44.432 31.304 44.6336 31.1453C44.8352 30.9867 45.0014 30.7925 45.1339 30.5648C45.2646 30.3352 45.356 30.0776 45.4064 29.7864L48.3427 29.8032C48.2904 30.3333 48.1355 30.8579 47.8798 31.3749ZM27.9998 51.5088C21.5019 51.5088 15.62 48.8787 11.3603 44.6227L27.9998 28L11.3603 11.3773C15.62 7.12134 21.5019 4.49121 27.9998 4.49121C34.4976 4.49121 40.3795 7.12321 44.6392 11.3773L27.9998 28L44.6392 44.6227C40.3795 48.8787 34.4976 51.5088 27.9998 51.5088ZM8.22244 34.0088V21.9912H13.2382C14.1398 21.9912 14.8939 22.1181 15.5024 22.372C16.111 22.6277 16.5683 22.9824 16.8763 23.4397C17.1843 23.8971 17.3374 24.4272 17.3374 25.0301C17.3374 25.4875 17.2422 25.8963 17.0499 26.2528C16.8576 26.6112 16.5944 26.908 16.2566 27.1413C15.9206 27.3765 15.5304 27.5408 15.088 27.6341V27.7517C15.5734 27.776 16.0232 27.9067 16.4358 28.1456C16.8502 28.3845 17.1806 28.7168 17.4326 29.1405C17.6827 29.5661 17.8078 30.0683 17.8078 30.6451C17.8078 31.2909 17.6435 31.8659 17.315 32.3736C16.9864 32.8795 16.5104 33.2789 15.887 33.5701C15.2635 33.8613 14.5094 34.0069 13.619 34.0069H8.22244V34.0088ZM27.9998 0.959473C13.0515 0.959473 0.933105 13.0648 0.933105 28C0.933105 42.9333 13.0515 55.0405 27.9998 55.0405C42.948 55.0405 55.0664 42.9333 55.0664 28C55.0664 13.0648 42.948 0.959473 27.9998 0.959473ZM13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM13.9438 24.6437C13.6582 24.4123 13.2718 24.2984 12.7864 24.2984H11.1307V26.9323H12.7398C13.0571 26.9323 13.339 26.88 13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1907 14.2294 24.8752 13.9438 24.6437Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <svg
                            onClick={() => (setPage(0), setProductsAll(true))}
                            className="absolute top-0 left-0 text-base font-medium text-white rounded-full hover:bg-gray-600 hover:text-white mt-7 ml-7 md723:hidden"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18 6L6 18"
                                stroke="currentColor"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M6 6L18 18"
                                stroke="currentColor"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                        <div className="absolute text-center md723:top-auto bottom-14 md723:bottom-auto ">
                            <p className="px-3 text-2xl font-bold text-white md723:text-3xl lg1170:text-5xl lg:text-4xl ">
                                ¿Dónde se encuentra tu
                            </p>
                            <p className="px-3 mt-3 text-2xl font-bold text-white md723:text-3xl lg1170:text-5xl lg:text-4xl">
                                {onboarding.tipo_producto === "casa"
                                    ? "alojamiento?"
                                    : "embarcación?"}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center md723:items-center h-2/3 md723:h-screen md723:relative">
                    <div className="hidden text-right md723:block">
                        <p
                            onClick={() => (setPage(0), setProductsAll(true))}
                            className="text-[#053465] font-medium mt-7 mr-10 text-base top-0 right-0 absolute cursor-pointer ">
                            Salir
                        </p>
                    </div>

                    <div className="pt-3 pl-4 md723:pt-0">
                        <div className="h-[47vh] md723:h-[70vh] overflow-hidden">
                            <div className="h-[47vh] md723:h-[70vh] overflow-auto w-[105%]">
                                <label className=" text-base text-[#3C3C3C]">
                                    Señale la direccion de su propiedad en el
                                    mapa
                                </label>
                                <div className="w-[300px] md723:w-[400px] h-80 mt-2 relative">
                                    <StandaloneSearchBox
                                        onLoad={onSearchBoxMounted}
                                        onPlacesChanged={handlePlacesChanged}>
                                        <input
                                            type="text"
                                            placeholder="Busca un lugar"
                                            className="input-box"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `240px`,
                                                height: `32px`,
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                                position: "absolute",
                                                left: "50%",
                                                marginLeft: "-120px",
                                                top: "10px",
                                                zIndex: "10",
                                            }}
                                        />
                                    </StandaloneSearchBox>
                                    <GoogleMap
                                        options={{ disableDefaultUI: true }}
                                        mapContainerStyle={{
                                            height: "92%",
                                            width: "100%",
                                            position: "relative",
                                            borderRadius: "8px",
                                        }}
                                        center={{
                                            lat: Number(coordinates.lat),
                                            lng: Number(coordinates.lng),
                                        }}
                                        zoom={coordinates.zoom}
                                        onDragEnd={() => {
                                            const newCenter =
                                                mapRef.current.getCenter();
                                            setCoordinates({
                                                lat: newCenter.lat(),
                                                lng: newCenter.lng(),
                                                zoom: mapRef.current.getZoom(),
                                            });
                                        }}
                                        onLoad={(map) =>
                                            (mapRef.current = map)
                                        }>
                                        <Marker
                                            position={{
                                                lat: Number(coordinates.lat),
                                                lng: Number(coordinates.lng),
                                            }}
                                            draggable={true}
                                            onDragEnd={(e) => {
                                                setCoordinates({
                                                    lat: e.latLng.lat(),
                                                    lng: e.latLng.lng(),
                                                });
                                            }}
                                        />
                                    </GoogleMap>
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 ">
                                    <label className="text-base text-[#3C3C3C]">
                                        Calle
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_address}
                                        name="property_address"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 ">
                                    <label className="text-base text-[#3C3C3C]">
                                        Número
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_number}
                                        name="property_number"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 ">
                                    <label className="text-base text-[#3C3C3C]">
                                        Ciudad
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_city}
                                        name="property_city"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 ">
                                    <label className="text-base text-[#3C3C3C]">
                                        Departamento/Estado/Provincia/Región
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_region}
                                        name="property_region"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 ">
                                    <label className="text-base text-[#3C3C3C]">
                                        Código postal
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_postalCode}
                                        name="property_postalCode"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                                <div className="w-[300px] md723:w-[400px] mt-2 mb-4">
                                    <label className="text-base text-[#3C3C3C]">
                                        País
                                    </label>

                                    <input
                                        autoComplete="off"
                                        value={ubication.property_country}
                                        name="property_country"
                                        onChange={handleInputChange}
                                        type={"text"}
                                        className="w-full px-3 py-2 my-3 bg-transparent border rounded-lg outline-none focus:outline-none"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="h-1 w-6/12 bg-[#053465] xs:bottom-0 xs:mb-[87px] mt-3 absolute left-0"></div>
                        <div className="border-t border-[#3C3C3C] flex justify-between items-center w-full xs:bottom-0 xs:mb-2 mt-4 absolute left-0 xs:py-3 ">
                            <div
                                onClick={() =>
                                    onboarding.tipo_producto === "casa"
                                        ? setPage(actualPage - 1)
                                        : setPage(actualPage - 3)
                                }
                                className="px-6 py-3 mx-5 mt-2 border rounded-lg cursor-pointer text-blue-bluecorner border-blue-bluecorner hover:bg-blue-bluecorner hover:text-white">
                                Atrás
                            </div>
                            <div
                                disabled={!siguiente}
                                onClick={() => nextPage()}
                                className="px-4 py-3 mx-5 mt-2 border rounded-lg cursor-pointer text-blue-bluecorner border-blue-bluecorner hover:bg-blue-bluecorner hover:text-white">
                                {siguiente ? siguiente : <Spinner width={5} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductUbication;
